module.exports = __webpack_public_path__ + "static/img/1.72ee7b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/1.png
// module id = 20R3
// module chunks = 0